import { Navigate } from "react-router-dom";
import Login from "../Login/Login"
import Dasboard from "../../Pages/Dasboard";
import { UnoStoreHooks } from "@simulanisindia/ui";
import Dashboard from "../../Pages/Dasboard";
import ModuleList from "../../Pages/ModuleList";
import MCreation from "../../Pages/MCreation";


const { useUnoSelector } = UnoStoreHooks;

const RedirectToDashboard = () => {
  const userData = useUnoSelector((state) => state.user);
  const uuid = userData?.user?.uuid;

  if (!uuid) return null;

  return <Navigate to={`/modules`} />;
};


export const privateRoutes = [
  {
    path: "/modules",
    element: ModuleList,
  },
  {
    path: "/modules/creation/:id",
    element: MCreation,
  },
  {
    path: "*",
    element: RedirectToDashboard,
  },
];


export const publicRoutes = [
    {
     path: "/gateway",
     element: Login
    }
];